var map = {
	"./Dashboard": [
		"7277",
		"chunk-06c002b4",
		"chunk-e5267ff6",
		"chunk-4acd3683"
	],
	"./Dashboard.vue": [
		"7277",
		"chunk-06c002b4",
		"chunk-e5267ff6",
		"chunk-4acd3683"
	],
	"./FranchiseDashboard": [
		"29dd",
		"chunk-54b2f52a"
	],
	"./FranchiseDashboard.vue": [
		"29dd",
		"chunk-54b2f52a"
	],
	"./admission/AddEditAdmissionDetails": [
		"bdcd",
		"chunk-a60283a8",
		"chunk-c5bde3b4"
	],
	"./admission/AddEditAdmissionDetails.vue": [
		"bdcd",
		"chunk-a60283a8",
		"chunk-c5bde3b4"
	],
	"./admission/Admissions": [
		"5b09",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-2f07b74c"
	],
	"./admission/Admissions.vue": [
		"5b09",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-2f07b74c"
	],
	"./admission/ManageEnquiries": [
		"3e45",
		"chunk-06c002b4",
		"chunk-07442875"
	],
	"./admission/ManageEnquiries.vue": [
		"3e45",
		"chunk-06c002b4",
		"chunk-07442875"
	],
	"./attendance/AttendanceData": [
		"dce0",
		"chunk-06c002b4",
		"chunk-1f943a5e"
	],
	"./attendance/AttendanceData.vue": [
		"dce0",
		"chunk-06c002b4",
		"chunk-1f943a5e"
	],
	"./attendance/AttendanceDetail": [
		"b194",
		"chunk-06c002b4",
		"chunk-681c6b9e"
	],
	"./attendance/AttendanceDetail.vue": [
		"b194",
		"chunk-06c002b4",
		"chunk-681c6b9e"
	],
	"./attendance/StudentAttendance": [
		"45de",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-9fac1f5a"
	],
	"./attendance/StudentAttendance.vue": [
		"45de",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-9fac1f5a"
	],
	"./attendance/TakeAttendance": [
		"9ce0",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-eb2897ec"
	],
	"./attendance/TakeAttendance.vue": [
		"9ce0",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-eb2897ec"
	],
	"./auth/LoginInstitute": [
		"88d9",
		"chunk-66fdca85"
	],
	"./auth/LoginInstitute.vue": [
		"88d9",
		"chunk-66fdca85"
	],
	"./auth/LoginUser": [
		"e9f7",
		"chunk-2d226cfb"
	],
	"./auth/LoginUser.vue": [
		"e9f7",
		"chunk-2d226cfb"
	],
	"./auth/Logout": [
		"6f8d",
		"chunk-2d0db312"
	],
	"./auth/Logout.vue": [
		"6f8d",
		"chunk-2d0db312"
	],
	"./auth/ResetPassword": [
		"0bff",
		"chunk-64f841b6"
	],
	"./auth/ResetPassword.vue": [
		"0bff",
		"chunk-64f841b6"
	],
	"./auth/Restricted": [
		"f4da",
		"chunk-2d22ce81"
	],
	"./auth/Restricted.vue": [
		"f4da",
		"chunk-2d22ce81"
	],
	"./classroom/AddClassroom": [
		"dc27",
		"chunk-1dc241ee",
		"chunk-5643cdeb"
	],
	"./classroom/AddClassroom.vue": [
		"dc27",
		"chunk-1dc241ee",
		"chunk-5643cdeb"
	],
	"./classroom/ClassroomDetails": [
		"82bb",
		"chunk-06c002b4",
		"chunk-05ee145e"
	],
	"./classroom/ClassroomDetails.vue": [
		"82bb",
		"chunk-06c002b4",
		"chunk-05ee145e"
	],
	"./classroom/ClassroomRecord": [
		"78dc",
		"chunk-06c002b4",
		"chunk-1139185c"
	],
	"./classroom/ClassroomRecord.vue": [
		"78dc",
		"chunk-06c002b4",
		"chunk-1139185c"
	],
	"./classroom/EditClassroom": [
		"b93b",
		"chunk-1dc241ee",
		"chunk-12fbc7e2"
	],
	"./classroom/EditClassroom.vue": [
		"b93b",
		"chunk-1dc241ee",
		"chunk-12fbc7e2"
	],
	"./default/PageNotFound": [
		"3307",
		"chunk-2d0b955d"
	],
	"./default/PageNotFound.vue": [
		"3307",
		"chunk-2d0b955d"
	],
	"./fees/AddEditFeeCategory": [
		"c97e",
		"chunk-89f5415a"
	],
	"./fees/AddEditFeeCategory.vue": [
		"c97e",
		"chunk-89f5415a"
	],
	"./fees/AddEditFeeParticular": [
		"5088",
		"chunk-2fef208d"
	],
	"./fees/AddEditFeeParticular.vue": [
		"5088",
		"chunk-2fef208d"
	],
	"./fees/AddEditFeeReceiptSettings": [
		"63b5",
		"chunk-4b33a759",
		"chunk-43a8a956",
		"chunk-d5515368"
	],
	"./fees/AddEditFeeReceiptSettings.vue": [
		"63b5",
		"chunk-4b33a759",
		"chunk-43a8a956",
		"chunk-d5515368"
	],
	"./fees/AddEditFeeSettingsSchedule": [
		"6823",
		"chunk-a60283a8",
		"chunk-63e6669e"
	],
	"./fees/AddEditFeeSettingsSchedule.vue": [
		"6823",
		"chunk-a60283a8",
		"chunk-63e6669e"
	],
	"./fees/CollectFee": [
		"3c99",
		"chunk-a60283a8",
		"chunk-5beb5aae"
	],
	"./fees/CollectFee.vue": [
		"3c99",
		"chunk-a60283a8",
		"chunk-5beb5aae"
	],
	"./fees/FeeReceiptSettings": [
		"806b",
		"chunk-7a208b68"
	],
	"./fees/FeeReceiptSettings.vue": [
		"806b",
		"chunk-7a208b68"
	],
	"./fees/FeeReports": [
		"51da",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-0aee1f9e"
	],
	"./fees/FeeReports.vue": [
		"51da",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-0aee1f9e"
	],
	"./fees/FeeSettings": [
		"cb35",
		"chunk-421b5c66"
	],
	"./fees/FeeSettings.vue": [
		"cb35",
		"chunk-421b5c66"
	],
	"./fees/FeeSettingsCategory": [
		"e6a5",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-b0034e82"
	],
	"./fees/FeeSettingsCategory.vue": [
		"e6a5",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-b0034e82"
	],
	"./fees/FeeSettingsParticulars": [
		"1f88",
		"chunk-3faf87a0"
	],
	"./fees/FeeSettingsParticulars.vue": [
		"1f88",
		"chunk-3faf87a0"
	],
	"./fees/FeeSettingsSchedule": [
		"d20c",
		"chunk-03e582d7"
	],
	"./fees/FeeSettingsSchedule.vue": [
		"d20c",
		"chunk-03e582d7"
	],
	"./fees/FeeSettingsStructure": [
		"2640",
		"chunk-5462635d"
	],
	"./fees/FeeSettingsStructure.vue": [
		"2640",
		"chunk-5462635d"
	],
	"./fees/FeeSettingsStructureCategories": [
		"cc21",
		"chunk-a8405b72"
	],
	"./fees/FeeSettingsStructureCategories.vue": [
		"cc21",
		"chunk-a8405b72"
	],
	"./fees/FeeSettingsStructureCategoryDetails": [
		"56eb",
		"chunk-06c002b4",
		"chunk-5257d6cc"
	],
	"./fees/FeeSettingsStructureCategoryDetails.vue": [
		"56eb",
		"chunk-06c002b4",
		"chunk-5257d6cc"
	],
	"./fees/FeesRecord": [
		"ae65",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-e5267ff6",
		"chunk-4fb8613b"
	],
	"./fees/FeesRecord.vue": [
		"ae65",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-e5267ff6",
		"chunk-4fb8613b"
	],
	"./fees/FeesRecordNew": [
		"c9ad",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-e5267ff6",
		"chunk-5512c41e"
	],
	"./fees/FeesRecordNew.vue": [
		"c9ad",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-e5267ff6",
		"chunk-5512c41e"
	],
	"./fees/FeesRecordOld": [
		"bbbb",
		"chunk-06c002b4",
		"chunk-e5267ff6",
		"chunk-61661a14"
	],
	"./fees/FeesRecordOld.vue": [
		"bbbb",
		"chunk-06c002b4",
		"chunk-e5267ff6",
		"chunk-61661a14"
	],
	"./fees/ManageFeeTags": [
		"f552",
		"chunk-06c002b4",
		"chunk-70c239db"
	],
	"./fees/ManageFeeTags.vue": [
		"f552",
		"chunk-06c002b4",
		"chunk-70c239db"
	],
	"./fees/StudentFeeDetails": [
		"00db",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-eaca0fe4"
	],
	"./fees/StudentFeeDetails.vue": [
		"00db",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-eaca0fe4"
	],
	"./fees/ViewFeeReceipt": [
		"cfce",
		"chunk-4b33a759",
		"chunk-90ad9556"
	],
	"./fees/ViewFeeReceipt.vue": [
		"cfce",
		"chunk-4b33a759",
		"chunk-90ad9556"
	],
	"./fees/ViewFeesPaid": [
		"112c",
		"chunk-4b33a759",
		"chunk-78041dac"
	],
	"./fees/ViewFeesPaid.vue": [
		"112c",
		"chunk-4b33a759",
		"chunk-78041dac"
	],
	"./fees/ViewRefund": [
		"9a16",
		"chunk-346c9088"
	],
	"./fees/ViewRefund.vue": [
		"9a16",
		"chunk-346c9088"
	],
	"./fees/ViewRefundReceipt": [
		"683b",
		"chunk-49e5b9d5"
	],
	"./fees/ViewRefundReceipt.vue": [
		"683b",
		"chunk-49e5b9d5"
	],
	"./finance/AddEditIncomeReceiptSettings": [
		"abf5",
		"chunk-4b33a759",
		"chunk-43a8a956",
		"chunk-33420a13"
	],
	"./finance/AddEditIncomeReceiptSettings.vue": [
		"abf5",
		"chunk-4b33a759",
		"chunk-43a8a956",
		"chunk-33420a13"
	],
	"./finance/AllFinanceAccounts": [
		"aa12",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-2d212b37"
	],
	"./finance/AllFinanceAccounts.vue": [
		"aa12",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-2d212b37"
	],
	"./finance/AllIncomeReceiptSettings": [
		"b6d3",
		"chunk-2d210459"
	],
	"./finance/AllIncomeReceiptSettings.vue": [
		"b6d3",
		"chunk-2d210459"
	],
	"./finance/AllTransactions": [
		"fb1a",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-4ae7dbfb"
	],
	"./finance/AllTransactions.vue": [
		"fb1a",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-4ae7dbfb"
	],
	"./finance/AuthorizeExpenses": [
		"bee6",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-2d221d85",
		"chunk-562946fb"
	],
	"./finance/AuthorizeExpenses.vue": [
		"bee6",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-2d221d85",
		"chunk-562946fb"
	],
	"./finance/Expenses": [
		"b309",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-2d221d85",
		"chunk-fff075da"
	],
	"./finance/Expenses.vue": [
		"b309",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-2d221d85",
		"chunk-fff075da"
	],
	"./finance/FinanceCategories": [
		"1771",
		"chunk-06c002b4",
		"chunk-2d0abc76"
	],
	"./finance/FinanceCategories.vue": [
		"1771",
		"chunk-06c002b4",
		"chunk-2d0abc76"
	],
	"./finance/FinanceDashboard": [
		"3318",
		"chunk-3cfb0415"
	],
	"./finance/FinanceDashboard.vue": [
		"3318",
		"chunk-3cfb0415"
	],
	"./finance/FinancePreferences": [
		"068a",
		"chunk-2d0a44a5"
	],
	"./finance/FinancePreferences.vue": [
		"068a",
		"chunk-2d0a44a5"
	],
	"./finance/FinanceSettings": [
		"8e16",
		"chunk-2d0e9708"
	],
	"./finance/FinanceSettings.vue": [
		"8e16",
		"chunk-2d0e9708"
	],
	"./finance/Incomes": [
		"5cf8",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-2d221d85",
		"chunk-7ada55d0"
	],
	"./finance/Incomes.vue": [
		"5cf8",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-2d221d85",
		"chunk-7ada55d0"
	],
	"./finance/OldAllTransactions": [
		"0a59",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-be4f24cc"
	],
	"./finance/OldAllTransactions.vue": [
		"0a59",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-be4f24cc"
	],
	"./finance/OldExpenses": [
		"c124",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-65396121"
	],
	"./finance/OldExpenses.vue": [
		"c124",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-65396121"
	],
	"./finance/OldIncomes": [
		"9030",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-4c89ec31"
	],
	"./finance/OldIncomes.vue": [
		"9030",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-4c89ec31"
	],
	"./finance/PrintIncomeReceipt": [
		"73a9",
		"chunk-4b33a759",
		"chunk-52637f5c"
	],
	"./finance/PrintIncomeReceipt.vue": [
		"73a9",
		"chunk-4b33a759",
		"chunk-52637f5c"
	],
	"./finance/TransactionsReport": [
		"9124",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-6bb439e4"
	],
	"./finance/TransactionsReport.vue": [
		"9124",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-6bb439e4"
	],
	"./help/HelpCenter": [
		"bbed",
		"chunk-2d21a9d5"
	],
	"./help/HelpCenter.vue": [
		"bbed",
		"chunk-2d21a9d5"
	],
	"./help/HelpDescription": [
		"4acf",
		"chunk-4b33a759",
		"chunk-ecc0a0b6"
	],
	"./help/HelpDescription.vue": [
		"4acf",
		"chunk-4b33a759",
		"chunk-ecc0a0b6"
	],
	"./help/HelpSubGroup": [
		"cf3f",
		"chunk-2d22272c"
	],
	"./help/HelpSubGroup.vue": [
		"cf3f",
		"chunk-2d22272c"
	],
	"./inventory/AddEditItemCategory": [
		"16da",
		"chunk-2d0abe58"
	],
	"./inventory/AddEditItemCategory.vue": [
		"16da",
		"chunk-2d0abe58"
	],
	"./inventory/AddEditItemUnit": [
		"3ff1",
		"chunk-b6156cac"
	],
	"./inventory/AddEditItemUnit.vue": [
		"3ff1",
		"chunk-b6156cac"
	],
	"./inventory/AddEditPurchaseOrder": [
		"2ad6",
		"chunk-a60283a8",
		"chunk-88d5a59a"
	],
	"./inventory/AddEditPurchaseOrder.vue": [
		"2ad6",
		"chunk-a60283a8",
		"chunk-88d5a59a"
	],
	"./inventory/AddEditStore": [
		"4cb0",
		"chunk-25d8d144"
	],
	"./inventory/AddEditStore.vue": [
		"4cb0",
		"chunk-25d8d144"
	],
	"./inventory/AddEditStoreCategory": [
		"6066",
		"chunk-52b2d63e"
	],
	"./inventory/AddEditStoreCategory.vue": [
		"6066",
		"chunk-52b2d63e"
	],
	"./inventory/AddEditStoreItem": [
		"32f2",
		"chunk-1d5c87c2"
	],
	"./inventory/AddEditStoreItem.vue": [
		"32f2",
		"chunk-1d5c87c2"
	],
	"./inventory/AddEditStoreType": [
		"d204",
		"chunk-920f58a0"
	],
	"./inventory/AddEditStoreType.vue": [
		"d204",
		"chunk-920f58a0"
	],
	"./inventory/AddEditSupplier": [
		"8133",
		"chunk-29ea98da"
	],
	"./inventory/AddEditSupplier.vue": [
		"8133",
		"chunk-29ea98da"
	],
	"./inventory/AddEditSupplierType": [
		"a0d5",
		"chunk-e51d61d6"
	],
	"./inventory/AddEditSupplierType.vue": [
		"a0d5",
		"chunk-e51d61d6"
	],
	"./inventory/GRNDetails": [
		"a3a9",
		"chunk-2d208460"
	],
	"./inventory/GRNDetails.vue": [
		"a3a9",
		"chunk-2d208460"
	],
	"./inventory/GRNs": [
		"d006",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-1fd2dbfe"
	],
	"./inventory/GRNs.vue": [
		"d006",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-1fd2dbfe"
	],
	"./inventory/InventoryDashboard": [
		"e533",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-3f7ffee7"
	],
	"./inventory/InventoryDashboard.vue": [
		"e533",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-3f7ffee7"
	],
	"./inventory/InventoryItems": [
		"3460",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-66b851a0"
	],
	"./inventory/InventoryItems.vue": [
		"3460",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-66b851a0"
	],
	"./inventory/InventorySettings": [
		"8074",
		"chunk-2d0dd0cb"
	],
	"./inventory/InventorySettings.vue": [
		"8074",
		"chunk-2d0dd0cb"
	],
	"./inventory/ItemCategory": [
		"b641",
		"chunk-2d20fe87"
	],
	"./inventory/ItemCategory.vue": [
		"b641",
		"chunk-2d20fe87"
	],
	"./inventory/PurchaseOrderDetails": [
		"4d64d",
		"chunk-a60283a8",
		"chunk-144e4ded"
	],
	"./inventory/PurchaseOrderDetails.vue": [
		"4d64d",
		"chunk-a60283a8",
		"chunk-144e4ded"
	],
	"./inventory/PurchaseOrders": [
		"7737",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-335f5ee2"
	],
	"./inventory/PurchaseOrders.vue": [
		"7737",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-335f5ee2"
	],
	"./inventory/StoreCategory": [
		"84d4",
		"chunk-2d0de542"
	],
	"./inventory/StoreCategory.vue": [
		"84d4",
		"chunk-2d0de542"
	],
	"./inventory/StoreDetails": [
		"9c20",
		"chunk-06c002b4",
		"chunk-36fe43d7"
	],
	"./inventory/StoreDetails.vue": [
		"9c20",
		"chunk-06c002b4",
		"chunk-36fe43d7"
	],
	"./inventory/StoreItemDetails": [
		"1a40",
		"chunk-06c002b4",
		"chunk-5c7e89bc"
	],
	"./inventory/StoreItemDetails.vue": [
		"1a40",
		"chunk-06c002b4",
		"chunk-5c7e89bc"
	],
	"./inventory/StoreType": [
		"0060",
		"chunk-2d0a2db0"
	],
	"./inventory/StoreType.vue": [
		"0060",
		"chunk-2d0a2db0"
	],
	"./inventory/SupplierType": [
		"570c",
		"chunk-2d0c8d4b"
	],
	"./inventory/SupplierType.vue": [
		"570c",
		"chunk-2d0c8d4b"
	],
	"./inventory/Suppliers": [
		"94a2",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-29a21e4c"
	],
	"./inventory/Suppliers.vue": [
		"94a2",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-29a21e4c"
	],
	"./onboarding/ClassroomSetup": [
		"705f",
		"chunk-379ff4ff"
	],
	"./onboarding/ClassroomSetup.vue": [
		"705f",
		"chunk-379ff4ff"
	],
	"./onboarding/InstitutionSetup": [
		"44d3",
		"chunk-4222043d"
	],
	"./onboarding/InstitutionSetup.vue": [
		"44d3",
		"chunk-4222043d"
	],
	"./onboarding/ModulesSetup": [
		"d68b",
		"chunk-1056f552"
	],
	"./onboarding/ModulesSetup.vue": [
		"d68b",
		"chunk-1056f552"
	],
	"./onboarding/StaffSetup": [
		"742c",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-5a6dcf72"
	],
	"./onboarding/StaffSetup.vue": [
		"742c",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-5a6dcf72"
	],
	"./onboarding/StudentsSetup": [
		"39b4",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-3e292704"
	],
	"./onboarding/StudentsSetup.vue": [
		"39b4",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-3e292704"
	],
	"./onlineportal/ApplicationForm": [
		"9e3c",
		"chunk-e032d1b2"
	],
	"./onlineportal/ApplicationForm.vue": [
		"9e3c",
		"chunk-e032d1b2"
	],
	"./payroll/AddEditPayrollGroups": [
		"9e83",
		"chunk-06c002b4",
		"chunk-57367a9e"
	],
	"./payroll/AddEditPayrollGroups.vue": [
		"9e83",
		"chunk-06c002b4",
		"chunk-57367a9e"
	],
	"./payroll/AllPayrollGroups": [
		"e281",
		"chunk-06c002b4",
		"chunk-1ad91a36"
	],
	"./payroll/AllPayrollGroups.vue": [
		"e281",
		"chunk-06c002b4",
		"chunk-1ad91a36"
	],
	"./payroll/ApprovedPayslips": [
		"1cc0",
		"chunk-06c002b4",
		"chunk-38d624dc"
	],
	"./payroll/ApprovedPayslips.vue": [
		"1cc0",
		"chunk-06c002b4",
		"chunk-38d624dc"
	],
	"./payroll/EditEmployeePayslip": [
		"a26f",
		"chunk-b8d568ee"
	],
	"./payroll/EditEmployeePayslip.vue": [
		"a26f",
		"chunk-b8d568ee"
	],
	"./payroll/GeneratePayslips": [
		"3e44",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-3f879918"
	],
	"./payroll/GeneratePayslips.vue": [
		"3e44",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-3f879918"
	],
	"./payroll/PayrollAccountDetails": [
		"1f26",
		"chunk-06c002b4",
		"chunk-3c2f559d"
	],
	"./payroll/PayrollAccountDetails.vue": [
		"1f26",
		"chunk-06c002b4",
		"chunk-3c2f559d"
	],
	"./payroll/PayrollDashboard": [
		"647e",
		"chunk-06c002b4",
		"chunk-2ebb6dd0"
	],
	"./payroll/PayrollDashboard.vue": [
		"647e",
		"chunk-06c002b4",
		"chunk-2ebb6dd0"
	],
	"./payroll/PayrollParticulars": [
		"7c3b",
		"chunk-06c002b4",
		"chunk-2d0e1b91"
	],
	"./payroll/PayrollParticulars.vue": [
		"7c3b",
		"chunk-06c002b4",
		"chunk-2d0e1b91"
	],
	"./payroll/PayrollSettings": [
		"862a",
		"chunk-fdc788ae"
	],
	"./payroll/PayrollSettings.vue": [
		"862a",
		"chunk-fdc788ae"
	],
	"./payroll/PayslipSettings": [
		"4611",
		"chunk-06c002b4",
		"chunk-2343fc24"
	],
	"./payroll/PayslipSettings.vue": [
		"4611",
		"chunk-06c002b4",
		"chunk-2343fc24"
	],
	"./payroll/PendingPayslips": [
		"91c6",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b977f530"
	],
	"./payroll/PendingPayslips.vue": [
		"91c6",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b977f530"
	],
	"./payroll/PrintPayslip": [
		"9b28",
		"chunk-4498be80"
	],
	"./payroll/PrintPayslip.vue": [
		"9b28",
		"chunk-4498be80"
	],
	"./payroll/RejectedPayslips": [
		"a3f2",
		"chunk-06c002b4",
		"chunk-4ab5806d"
	],
	"./payroll/RejectedPayslips.vue": [
		"a3f2",
		"chunk-06c002b4",
		"chunk-4ab5806d"
	],
	"./payroll/ViewPayslip": [
		"b4b2",
		"chunk-4bb2d4e8"
	],
	"./payroll/ViewPayslip.vue": [
		"b4b2",
		"chunk-4bb2d4e8"
	],
	"./reportcard/ReportCards": [
		"ccbd",
		"chunk-679c0793"
	],
	"./reportcard/ReportCards.vue": [
		"ccbd",
		"chunk-679c0793"
	],
	"./reportcard/SubjectWiseMarkSheet": [
		"6058",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-d6518c60"
	],
	"./reportcard/SubjectWiseMarkSheet.vue": [
		"6058",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-d6518c60"
	],
	"./reportcard/UploadAllSubjectsMarkSheet": [
		"dcde",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-21921829"
	],
	"./reportcard/UploadAllSubjectsMarkSheet.vue": [
		"dcde",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-21921829"
	],
	"./settings/InstitutionDetailsSettings": [
		"5206",
		"chunk-2dc822fa"
	],
	"./settings/InstitutionDetailsSettings.vue": [
		"5206",
		"chunk-2dc822fa"
	],
	"./settings/InstitutionSettings": [
		"a2fc",
		"chunk-2d208164"
	],
	"./settings/InstitutionSettings.vue": [
		"a2fc",
		"chunk-2d208164"
	],
	"./settings/PermissionSettings": [
		"4045",
		"chunk-7ffa2337"
	],
	"./settings/PermissionSettings.vue": [
		"4045",
		"chunk-7ffa2337"
	],
	"./settings/UserAttributes": [
		"6321",
		"chunk-06c002b4",
		"chunk-2d0cf2b2"
	],
	"./settings/UserAttributes.vue": [
		"6321",
		"chunk-06c002b4",
		"chunk-2d0cf2b2"
	],
	"./settings/UserDocumentTypes": [
		"c7ab",
		"chunk-06c002b4",
		"chunk-2d217c4b"
	],
	"./settings/UserDocumentTypes.vue": [
		"c7ab",
		"chunk-06c002b4",
		"chunk-2d217c4b"
	],
	"./settings/recycle_bin/DeletedCurrentRecords": [
		"96e3",
		"chunk-06c002b4",
		"chunk-2d0e6141"
	],
	"./settings/recycle_bin/DeletedCurrentRecords.vue": [
		"96e3",
		"chunk-06c002b4",
		"chunk-2d0e6141"
	],
	"./settings/recycle_bin/DeletedStaff": [
		"bf5c",
		"chunk-06c002b4",
		"chunk-2d21b308"
	],
	"./settings/recycle_bin/DeletedStaff.vue": [
		"bf5c",
		"chunk-06c002b4",
		"chunk-2d21b308"
	],
	"./settings/recycle_bin/DeletedStudents": [
		"c366",
		"chunk-06c002b4",
		"chunk-2d2167e6"
	],
	"./settings/recycle_bin/DeletedStudents.vue": [
		"c366",
		"chunk-06c002b4",
		"chunk-2d2167e6"
	],
	"./staff/AddEditStaff": [
		"f498",
		"chunk-a60283a8",
		"chunk-2bfa7d0d"
	],
	"./staff/AddEditStaff.vue": [
		"f498",
		"chunk-a60283a8",
		"chunk-2bfa7d0d"
	],
	"./staff/ManageDepartments": [
		"fecd",
		"chunk-06c002b4",
		"chunk-faf4daaa"
	],
	"./staff/ManageDepartments.vue": [
		"fecd",
		"chunk-06c002b4",
		"chunk-faf4daaa"
	],
	"./staff/StaffDetails": [
		"9ce6",
		"chunk-65583863"
	],
	"./staff/StaffDetails.vue": [
		"9ce6",
		"chunk-65583863"
	],
	"./staff/StaffRecord": [
		"5610",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-04b8fca5"
	],
	"./staff/StaffRecord.vue": [
		"5610",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-04b8fca5"
	],
	"./staff/dailyReports/DailyReports": [
		"ba37",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-4b33a759",
		"chunk-29020e08"
	],
	"./staff/dailyReports/DailyReports.vue": [
		"ba37",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-4b33a759",
		"chunk-29020e08"
	],
	"./staff_attendance/AddEditLeaveType": [
		"9812",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-9555c47c"
	],
	"./staff_attendance/AddEditLeaveType.vue": [
		"9812",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-9555c47c"
	],
	"./staff_attendance/AddEditStaffCategory": [
		"2d18",
		"chunk-e5267ff6",
		"chunk-bb8b4b8e"
	],
	"./staff_attendance/AddEditStaffCategory.vue": [
		"2d18",
		"chunk-e5267ff6",
		"chunk-bb8b4b8e"
	],
	"./staff_attendance/ApplyLeave": [
		"0ba0",
		"chunk-a60283a8",
		"chunk-238c14f4"
	],
	"./staff_attendance/ApplyLeave.vue": [
		"0ba0",
		"chunk-a60283a8",
		"chunk-238c14f4"
	],
	"./staff_attendance/AttendanceSettingsCategory": [
		"da4f",
		"chunk-06c002b4",
		"chunk-1c436af2"
	],
	"./staff_attendance/AttendanceSettingsCategory.vue": [
		"da4f",
		"chunk-06c002b4",
		"chunk-1c436af2"
	],
	"./staff_attendance/LeaveDetails": [
		"7519",
		"chunk-ed128836"
	],
	"./staff_attendance/LeaveDetails.vue": [
		"7519",
		"chunk-ed128836"
	],
	"./staff_attendance/QuickStaffAttendance": [
		"2b0c",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-76e7cd5a"
	],
	"./staff_attendance/QuickStaffAttendance.vue": [
		"2b0c",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-76e7cd5a"
	],
	"./staff_attendance/StaffAttendanceData": [
		"5efe",
		"chunk-06c002b4",
		"chunk-308030e9"
	],
	"./staff_attendance/StaffAttendanceData.vue": [
		"5efe",
		"chunk-06c002b4",
		"chunk-308030e9"
	],
	"./staff_attendance/StaffAttendanceDetail": [
		"d74b",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-e35ecdea"
	],
	"./staff_attendance/StaffAttendanceDetail.vue": [
		"d74b",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-e35ecdea"
	],
	"./staff_attendance/StaffAttendanceSetting": [
		"cb7a",
		"chunk-5480ec7c"
	],
	"./staff_attendance/StaffAttendanceSetting.vue": [
		"cb7a",
		"chunk-5480ec7c"
	],
	"./staff_attendance/StaffCalendar": [
		"6a43",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-acf4b51c"
	],
	"./staff_attendance/StaffCalendar.vue": [
		"6a43",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-acf4b51c"
	],
	"./staff_attendance/StaffLeaveAccounts": [
		"7e42",
		"chunk-06c002b4",
		"chunk-d9406fee"
	],
	"./staff_attendance/StaffLeaveAccounts.vue": [
		"7e42",
		"chunk-06c002b4",
		"chunk-d9406fee"
	],
	"./staff_attendance/StaffLeaveRecord": [
		"d466",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-2f0e8967"
	],
	"./staff_attendance/StaffLeaveRecord.vue": [
		"d466",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-2f0e8967"
	],
	"./staff_attendance/StaffLeaveTypes": [
		"e099",
		"chunk-2d2245c1"
	],
	"./staff_attendance/StaffLeaveTypes.vue": [
		"e099",
		"chunk-2d2245c1"
	],
	"./staff_attendance/StaffMonthlyAttendance": [
		"4c89",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-2f7e3f19"
	],
	"./staff_attendance/StaffMonthlyAttendance.vue": [
		"4c89",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-e5267ff6",
		"chunk-2f7e3f19"
	],
	"./students/AddEditStudent": [
		"c500",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-96aae14a"
	],
	"./students/AddEditStudent.vue": [
		"c500",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-96aae14a"
	],
	"./students/StudentDetails": [
		"7949",
		"chunk-729755c6"
	],
	"./students/StudentDetails.vue": [
		"7949",
		"chunk-729755c6"
	],
	"./students/StudentRecord": [
		"9688",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-a708a27c"
	],
	"./students/StudentRecord.vue": [
		"9688",
		"chunk-06c002b4",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-a708a27c"
	],
	"./syllabus/SyllabusPlanner": [
		"9ede",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-09846050"
	],
	"./syllabus/SyllabusPlanner.vue": [
		"9ede",
		"chunk-06c002b4",
		"chunk-a60283a8",
		"chunk-b1232318",
		"chunk-09846050"
	],
	"./task/AllTasks": [
		"ad52",
		"chunk-595deb30"
	],
	"./task/AllTasks.vue": [
		"ad52",
		"chunk-595deb30"
	],
	"./task/ManageTaskTags": [
		"f1de",
		"chunk-06c002b4",
		"chunk-625019d2"
	],
	"./task/ManageTaskTags.vue": [
		"f1de",
		"chunk-06c002b4",
		"chunk-625019d2"
	],
	"./templating/TemplateDocuments": [
		"86cd",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-0335a4a6"
	],
	"./templating/TemplateDocuments.vue": [
		"86cd",
		"chunk-06c002b4",
		"chunk-b1232318",
		"chunk-31a4a909",
		"chunk-6df3b2fe",
		"chunk-0335a4a6"
	],
	"./timetable/ClassroomTimetable": [
		"aa75",
		"chunk-06c002b4",
		"chunk-2d216257",
		"chunk-70ea3633"
	],
	"./timetable/ClassroomTimetable.vue": [
		"aa75",
		"chunk-06c002b4",
		"chunk-2d216257",
		"chunk-70ea3633"
	],
	"./timetable/CreateEditTimetable": [
		"9f18",
		"chunk-822b3b84"
	],
	"./timetable/CreateEditTimetable.vue": [
		"9f18",
		"chunk-822b3b84"
	],
	"./timetable/StaffTimetable": [
		"d49f",
		"chunk-06c002b4",
		"chunk-2d216257",
		"chunk-1764e819"
	],
	"./timetable/StaffTimetable.vue": [
		"d49f",
		"chunk-06c002b4",
		"chunk-2d216257",
		"chunk-1764e819"
	],
	"./timetable/TimeTableSlots": [
		"fde5",
		"chunk-06c002b4",
		"chunk-c7871b90"
	],
	"./timetable/TimeTableSlots.vue": [
		"fde5",
		"chunk-06c002b4",
		"chunk-c7871b90"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9dac";
module.exports = webpackAsyncContext;